export const CRISP_OPEN_CLASS = 'crisp-open';

export default class CrispHelper {
  static chatClosed() {
    document.body.classList.remove(CRISP_OPEN_CLASS);
  }

  static chatOpened() {
    document.body.classList.add(CRISP_OPEN_CLASS);
  }

  static openChat() {
    if (typeof $crisp === 'undefined') return;

    $crisp.push([
      'do',
      'chat:open',
    ]);
  }

  static setUserEmail(email) {
    if (typeof $crisp === 'undefined') return;

    if (!email) return;

    $crisp.push([
      'set',
      'user:email',
      email,
    ]);
  }

  static setupCrisp() {
    if (typeof $crisp === 'undefined') return;

    $crisp.push([
      'on',
      'chat:opened',
      CrispHelper.chatOpened,
    ]);

    $crisp.push([
      'on',
      'chat:closed',
      CrispHelper.chatClosed,
    ]);
  }
}
